import React from "react"
import { Helmet } from "react-helmet"
import { createPortal } from "react-dom"
import { currentDomain, currentPath } from "../Index"

import Deposit from "../transactions/Deposit"

import ModulesLotteryDraw from "./promotion_modules/modules_lotterDraw"
import ModulePeraBayong from "./promotion_modules/modules_peraBayong"
import ModuleRaceToRiches from "./promotion_modules/modules_racetoRiches"
import ModuleKingOfTheReels from "./promotion_modules/modules_kingOfTheReels"
import ModuleJustDoYourBest from "./promotion_modules/modules_justDoYourBest"
import ModuleFaChaiGrandSpinAle from "./promotion_modules/modules_fcGrandSpinAle"
import ModuleFlexiShowDown from "./promotion_modules/modules_flexiSpinShowdown"
import ModuleCQ9Funalo from "./promotion_modules/modules_cq9Funalo"
import ModuleLoveMagicSpin from "./promotion_modules/modules_loveMagicSpin"
import ModuleRaceOfReels from "./promotion_modules/ModuleRaceOfReels"
import ModuleBNGSplash from "./promotion_modules/ModuleBNGSplash"

import { usePromotionsPage } from "../data/usePromotionsPage"
import AppPromo from "../AppPromo"
import ModuleJiliGrandSlot from "./promotion_modules/ModuleJiliGrandSlot"
import ModuleRainOfWins from "./promotion_modules/ModuleRainOfWins"
import ModuleJDBWinnersLeague from "./promotion_modules/ModuleJDBWinnersLeague"

const modalComponents = {
  "2/30 Lottery Draw": ModulesLotteryDraw,
  "Pera O Bayong": ModulePeraBayong,
  "Race to Riches": ModuleRaceToRiches,
  "King of the Reels": ModuleKingOfTheReels,
  "JDB Exclusive Promo": ModuleJustDoYourBest,
  "FC Grand Spin-Ale": ModuleFaChaiGrandSpinAle,
  "Flexi-Spin Showdown": ModuleFlexiShowDown,
  "CQ9 Funalo": ModuleCQ9Funalo,
  "JDB Spin Tournament": ModuleLoveMagicSpin,
  "Race of Reels: Slots Tournament": ModuleRaceOfReels,
  "BNG Splash Spin Into Summer": ModuleBNGSplash,
  "Jili Grand Slot": ModuleJiliGrandSlot,
  "Rain Of Wins": ModuleRainOfWins,
  "JDB's Winners League": ModuleJDBWinnersLeague,
}

export default function Promotions() {
  const {
    isDepositOpen,
    setIsDepositOpen,

    ActiveModal,
    setActiveModal,
  } = usePromotionsPage({ modalComponents })

  return (
    <>
      <Helmet>
        <meta charSet="utf-8" />
        <title>Promotion - FGH - Your One-Stop Gaming Site</title>
        <link rel="icon" href="/images/fav.webp" sizes="32x32" />
        <meta name="description" content="ddd" />
        <link rel="canonical" href={`${currentDomain}${currentPath}`} />
      </Helmet>

      <AppPromo />

      {isDepositOpen &&
        createPortal(
          <div className="modal-portal">
            <Deposit
              onClose={() => setIsDepositOpen(false)}
              defaultBonusName="New Member Package Bonus"
            />
          </div>,
          document.body
        )}

      {ActiveModal && <ActiveModal closeModal={() => setActiveModal(null)} />}
    </>
  )
}
